<template>
  <div>
    <GiftSendModal
      :showFooter="false"
      :modalName="giftSendModalName"
      v-show="showModal"
      @confirmAction="handleConfirmAction($event)"
      buttonLabel="Finalize"
      colorVariation="coast"
      @hideModal="hideModal"
    >
      <template slot="header">
        <h4 class="header">Add Sends</h4>
      </template>

      <template slot="body">
        <p class="modal-description">
          Buy additional sends for <strong>$10/send</strong> to continue sending
          gifts on Swag Store. Please note sends purchased are non-refundable
          and have no expiration date.
        </p>
        <div class="modal-form">
          <p class="font-bold">Additional sends</p>
          <input
            type="number"
            placeholder="0"
            class="input-gemnote"
            v-model="giftSendCount"
            @input="validateGiftSendCount"
          />
        </div>
        <div class="modal-form">
          <div class="flex flex-row gap-1">
            <p><strong>Total</strong></p>
            <p>({{ giftSendCount || 0 }}x$10.00)</p>
          </div>
          <p>
            <strong
              >${{ ((Number(giftSendCount) || 1) * 10) | formatNumber }}</strong
            >
          </p>
        </div>
        <p class="modal-description">
          All charges will be billed to the payment method associated with Swag
          Store. To make changes, please go to <strong>Payments </strong> tab in
          <strong>Billings and Payments. </strong>
        </p>
        <div class="modal-cta">
          <button
            tag="button"
            :disabled="!isValidGiftSendCount"
            @click="handleConfirmAction"
            class="button-gemnote button-gemnote--small"
          >
            <span>Buy</span>
          </button>
        </div>
      </template>
    </GiftSendModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['showModal'],
  name: 'BuyGiftSendsModal',
  data() {
    return {
      giftSendModalName: 'giftSendModal',
      giftSendPrice: 0,
      giftSendCount: '',
    }
  },
  components: {
    GiftSendModal: () => import('@/components/Universal/RemoveModal'),
  },
  methods: {
    hideModal() {
      this.$emit('onCloseModal')
    },
    handleConfirmAction() {
      this.$store.dispatch('order/setAdditionalOrderLimit', this.giftSendCount)
      this.$emit('onCloseModal')
    },
    validateGiftSendCount() {
      if (Number(this.giftSendCount) <= 0 || isNaN(this.giftSendCount)) {
        this.giftSendCount = ''
      } else {
        this.giftSendCount = Math.abs(Math.floor(this.giftSendCount))
      }
    },
  },
  computed: {
    ...mapGetters({
      activeModals: 'modal/activeModals',
    }),
    isValidGiftSendCount() {
      return Number(this.giftSendCount) > 0
    },
  },
}
</script>
<style scoped lang="scss">
@import '@/global.scss';

.header {
  margin-bottom: 1.25rem;
  color: $pebble;
  font-family: $editorial;
  font-weight: normal;
  font-size: 2rem;
}

@media (max-width: 800px) {
  .header {
    line-height: 35px !important;
  }
}

.modal-description {
  font-size: 0.873rem;
  width: 80%;
  margin: 0 auto;
  color: $pebble;
  text-align: left;
}

@media (max-width: 800px) {
  .modal-description {
    width: 90%;
  }
}

.modal-form {
  display: flex;
  gap: 0.7rem;
  align-items: center;
  justify-content: center;
  margin: 1rem 0;

  p {
    font-size: 0.873rem;
    color: $pebble;
    width: max-content;
  }

  input {
    width: 60px;
    border-bottom: 1px solid #000000;
    height: 100%;
    color: $pebble !important;

    &::placeholder {
      color: $pebble !important;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}

.modal-cta {
  margin-top: 3rem;
  display: flex;
  justify-content: center;

  button {
    padding: 0px 3rem !important;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
}
</style>
